import {of, zip} from 'rxjs';
import i18next from 'i18next';
import {flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import * as ModalActions from 'web-app/react/modals-container/abstract-budget-modal/actions';

import * as API from './api';
import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetchBudget.type).mergeMap(({payload}) =>
        API.fetchBudget(payload.institutionId, payload.year, payload.type)
            .map(response => Actions.fetchBudgetSuccess.action(response, payload.type))
            .catch(e => of(Actions.fetchBudgetFailed.action(e))),
    );

const update = action$ =>
    action$.ofType(Actions.updateBudget.type).mergeMap(({payload}) =>
        zip(of(payload.year), API.updateBudget(payload.institutionId, payload.values, payload.type)).pipe(
            flatMap(zipped => [
                Actions.updateBudgetSuccess.action(zipped[1], zipped[0], payload.institutionId, payload.type),
                ModalActions.hide.action(),
                GlobalEventActions.updateSuccess.action(i18next.t('abstractBudget.budgetUpdated', {year: zipped[0]})),
            ]),
            catchError(e => of(Actions.updateBudgetFailed.action(e))),
        ),
    );

export default combineEpics(fetch, update);
